<template>
  <div class="ArchivePostItem">
    <div class="ArchivePostItem_Title" v-if="model.url">
      <a :href="'/blog/post/' + model.url"> {{ model.name || model.title }}</a>
    </div>
    <div class="ArchivePostItem_Date" v-if="model.published">
      {{ model.published | formatDate }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ArchivePostItem",
  props: {
    model: Object,
  },
};
</script>

<style>
.ArchivePostItem {
  color: white;
}

.ArchivePostItem a {
  color: white;
}
</style>